var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"fixed-table",attrs:{"headers":_vm.headers,"items":_vm.userList,"items-per-page":5,"dense":""}})}
var staticRenderFns = []

export { render, staticRenderFns }